// import React, { useEffect } from "react";
// import { Button, DatePicker, Select, Tooltip, Row, Col } from "antd";
// import dayjs from "dayjs";
// import { chartOptions, dateRanges } from "../Data/data";
// import { Typography } from "@mui/material";

// const { RangePicker } = DatePicker;
// const { Option } = Select;

// const DateEngineChartSelector = ({
//   selectedDates,
//   setSelectedDates,
//   engineType,
//   setEngineType,
//   selectedChart,
//   setSelectedChart,
//   selectedParameters,
//   setSelectedParameters,
//   setStartDate,
//   setEndDate,
//   Graph_data,
//   engineOptions,
//   parameterMappings,
//   timeFormat,
//   setTimeFormat,
// }) => {
//   if (selectedDates && selectedDates.length === 2) {
//     const startDate =
//       selectedDates[0] instanceof Date
//         ? selectedDates[0].toISOString().split("T")[0]
//         : new Date(selectedDates[0]).toISOString().split("T")[0];

//     const endDate =
//       selectedDates[1] instanceof Date
//         ? selectedDates[1].toISOString().split("T")[0]
//         : new Date(selectedDates[1]).toISOString().split("T")[0];
//     setStartDate(startDate);
//     setEndDate(endDate);
//   }

//   useEffect(() => {
//     if (engineOptions.length > 0 && (!engineType || engineType.length === 0)) {
//       const firstValue = [engineOptions[0].value];
//       setEngineType(firstValue);
//       handleEngineChange(firstValue);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [engineOptions]);

//   // Handlers
//   const handleDateChange = (dates) => setSelectedDates(dates);
//   const handleEngineChange = (item) => setEngineType(item);
//   const handleChartChange = (value) => setSelectedChart(value);
//   const handleParameterChange = (values, options) => {
//     const fullItems = options.map((opt) => ({
//       value: opt.props.item.value,
//       type: opt.props.item.type,
//     }));
//     setSelectedParameters(fullItems);
//   };

//   return (
//     <div style={{ padding: 10, width: "100%" }}>
//       <Row gutter={[16, 16]}>
//         {/* Date Range */}
//         <Col xs={24} sm={12} md={8} lg={6}>
//           <h4>Select Date Range</h4>
//           <RangePicker
//             presets={dateRanges}
//             onChange={handleDateChange}
//             value={
//               selectedDates && selectedDates.length
//                 ? [dayjs(selectedDates[0]), dayjs(selectedDates[1])]
//                 : setSelectedDates([dayjs().subtract(2, "day"), dayjs()])
//             }
//             format="YYYY-MM-DD"
//             style={{ width: "100%" }}
//             disabledDate={(current) =>
//               current && current > dayjs().endOf("day")
//             }
//           />
//         </Col>

//         {/* Machinery Type */}
//         <Col xs={24} sm={12} md={8} lg={6}>
//           <h4>Select Machinery Type</h4>
//           <Select
//             mode="multiple"
//             showSearch
//             placeholder="Select machinery type"
//             onChange={handleEngineChange}
//             value={engineType || []}
//             style={{ width: "100%" }}
//             maxTagCount={1}
//             maxTagPlaceholder={(omittedValues) => (
//               <Tooltip
//                 title={omittedValues.map(({ label }) => label).join(", ")}
//                 placement="topLeft"
//               >
//                 <span>+{omittedValues.length} more</span>
//               </Tooltip>
//             )}
//             filterOption={(input, option) =>
//               option?.children?.toLowerCase().includes(input.toLowerCase())
//             }
//           >
//             {engineOptions.map((engine) => (
//               <Option key={engine.value} value={engine.value}>
//                 {engine.label}
//               </Option>
//             ))}
//           </Select>
//         </Col>

//         {/* Parameters */}
//         <Col xs={24} sm={12} md={8} lg={6}>
//           <h4>Select Parameters (Multi-select)</h4>
//           <Select
//             mode="multiple"
//             showSearch
//             placeholder="Select Parameters"
//             onChange={handleParameterChange}
//             value={selectedParameters}
//             style={{ width: "100%" }}
//             maxTagCount={1}
//             maxTagPlaceholder={(omittedValues) => (
//               <Tooltip
//                 title={omittedValues.map(({ label }) => label).join(", ")}
//               >
//                 <span>+{omittedValues.length} more</span>
//               </Tooltip>
//             )}
//             filterOption={(input, option) =>
//               option?.children?.toLowerCase().includes(input.toLowerCase())
//             }
//           >
//             {Object.entries(parameterMappings || {}).flatMap(
//               ([group, params]) =>
//                 params.map((param) => (
//                   <Option key={param.value} value={param.value} item={param}>
//                     {param.label}
//                   </Option>
//                 ))
//             )}
//           </Select>
//         </Col>

//         {/* Chart Type */}
//         <Col xs={24} sm={12} md={8} lg={6}>
//           <h4>Select Chart Type</h4>
//           <Select
//             showSearch
//             placeholder="Select a chart type"
//             onChange={handleChartChange}
//             value={selectedChart || undefined}
//             style={{ width: "100%" }}
//             filterOption={(input, option) =>
//               option.children.toLowerCase().includes(input.toLowerCase())
//             }
//           >
//             {chartOptions.map((chart) => (
//               <Option key={chart.value} value={chart.value}>
//                 {chart.label}
//               </Option>
//             ))}
//           </Select>
//         </Col>

//         {/* Time Format */}
//         <Col xs={24} sm={12} md={8} lg={6}>
//           <Typography variant="body2">Time Format</Typography>
//           <Select
//             value={timeFormat}
//             style={{ width: "100%" }}
//             onChange={setTimeFormat}
//             options={[
//               { label: "Daily", value: "daily" },
//               { label: "Weekly", value: "weekly" },
//               { label: "Monthly", value: "monthly" },
//             ]}
//           />
//         </Col>

//         {/* Button */}
//         <Col xs={24} sm={12} md={8} lg={6}>
//           <Button
//             type="primary"
//             block
//             style={{
//               marginTop: "18px",
//               backgroundColor: "#E11236",
//               fontWeight: 900,
//             }}
//             onClick={Graph_data}
//           >
//             Generate Graph
//           </Button>
//         </Col>
//       </Row>
//     </div>
//   );
// };

// export default DateEngineChartSelector;

import React, { useEffect, useState } from "react";
import { Button, DatePicker, Select, Tooltip, Row, Col } from "antd";
import dayjs from "dayjs";
import { chartOptions, dateRanges } from "../Data/data";
import { Typography } from "@mui/material";

const { RangePicker } = DatePicker;
const { Option } = Select;

const DateEngineChartSelector = ({
  selectedDates,
  setSelectedDates,
  engineType,
  setEngineType,
  selectedChart,
  setSelectedChart,
  selectedParameters,
  setSelectedParameters,
  setStartDate,
  setEndDate,
  Graph_data,
  engineOptions,
  parameterMappings,
  timeFormat,
  setTimeFormat,
  setSelectedLogbook,
  selectedLogbook,
}) => {
  // if (selectedDates && selectedDates.length === 2) {
  //   const startDate =
  //     selectedDates[0] instanceof Date
  //       ? selectedDates[0].toISOString().split("T")[0]
  //       : new Date(selectedDates[0]).toISOString().split("T")[0];

  //   const endDate =
  //     selectedDates[1] instanceof Date
  //       ? selectedDates[1].toISOString().split("T")[0]
  //       : new Date(selectedDates[1]).toISOString().split("T")[0];
  //   setStartDate(startDate);
  //   setEndDate(endDate);
  // }

  useEffect(() => {
    if (engineOptions.length > 0 && (!engineType || engineType.length === 0)) {
      const firstValue = [engineOptions[0].value];
      setEngineType(firstValue);
      handleEngineChange(firstValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [engineOptions]);

  // Handlers
  // const handleDateChange = (dates) => setSelectedDates(dates);
  // const handleLogbookChange = (item) => {
  //   setSelectedLogbook(item);
  // };

  const handleDateChange = (dates) => {
  setSelectedDates(dates);

  if (dates && dates.length === 2) {
    const start = dayjs(dates[0]).format("YYYY-MM-DD");
    const end = dayjs(dates[1]).format("YYYY-MM-DD");
    setStartDate(start);
    setEndDate(end);
  }
};

const handleLogbookChange = (item) => {
  setSelectedLogbook(item);
};
  const handleEngineChange = (item) => setEngineType(item);
  const handleChartChange = (value) => setSelectedChart(value);
  const handleParameterChange = (values, options) => {
    const fullItems = options.map((opt) => ({
      value: opt.props.item.value,
      type: opt.props.item.type,
    }));
    setSelectedParameters(fullItems);
  };

  return (
    <div style={{ padding: 10, width: "100%" }}>
      <Row gutter={[16, 16]}>
        {/* Date Range */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <div className="selector-label">Select Date Range</div>
          <RangePicker
            presets={dateRanges}
            onChange={handleDateChange}
            // value={
            //   selectedDates && selectedDates.length
            //     ? [dayjs(selectedDates[0]), dayjs(selectedDates[1])]
            //     : setSelectedDates([dayjs().subtract(2, "day"), dayjs()])
            // }
            value={
  selectedDates && selectedDates.length === 2
    ? [dayjs(selectedDates[0]), dayjs(selectedDates[1])]
    : null
}
            format="YYYY-MM-DD"
            style={{ width: "100%" }}
            disabledDate={(current) =>
              current && current > dayjs().endOf("day")
            }
          />
        </Col>

        {/* Logbook Type */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <div className="selector-label">Select Logbook</div>
          
          <Select
            mode="multiple"
            showSearch
            placeholder="Select Logbook Type"
            maxTagCount={1}
            onChange={handleLogbookChange}
            value={selectedLogbook}
            style={{ width: "100%" }}
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
          >
            <Option value="engine_logbook">Engine Logbook</Option>
            <Option value="deck_logbook">Deck Logbook</Option>
            <Option value="daily_consumption_log">Daily Consumption Log</Option>
          </Select>
        </Col>

        {/* Show only if Engine Logbook selected */}
        {selectedLogbook.includes("engine_logbook") && (
          <>
            {/* Machinery Type */}
            <Col xs={24} sm={12} md={8} lg={6}>
              <div className="selector-label">Select Machinery Type</div>
              <Select
                mode="multiple"
                showSearch
                placeholder="Select machinery type"
                onChange={handleEngineChange}
                value={engineType || []}
                style={{ width: "100%" }}
                maxTagCount={1}
                maxTagPlaceholder={(omittedValues) => (
                  <Tooltip
                    title={omittedValues.map(({ label }) => label).join(", ")}
                    placement="topLeft"
                  >
                    <span>+{omittedValues.length} more</span>
                  </Tooltip>
                )}
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }
              >
                {engineOptions.map((engine) => (
                  <Option key={engine.value} value={engine.value}>
                    {engine.label}
                  </Option>
                ))}
              </Select>
            </Col>
            </>
  )}
            {/* Parameters */}
            <Col xs={24} sm={12} md={8} lg={6}>
              <div className="selector-label">Select Parameters</div>
              <Select
                mode="multiple"
                showSearch
                placeholder="Select Parameters"
                onChange={handleParameterChange}
                value={selectedParameters}
                style={{ width: "100%" }}
                maxTagCount={1}
                maxTagPlaceholder={(omittedValues) => (
                  <Tooltip
                    title={omittedValues.map(({ label }) => label).join(", ")}
                  >
                    <span>+{omittedValues.length} more</span>
                  </Tooltip>
                )}
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }
              >
                {Object.entries(parameterMappings || {}).flatMap(
                  ([group, params]) =>
                    params.map((param) => (
                      <Option
                        key={param.value}
                        value={param.value}
                        item={param}
                      >
                        {param.label}
                      </Option>
                    ))
                )}
              </Select>
            </Col>
         
      

        {/* Chart Type */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <div className="selector-label">Select Chart Type</div>
          <Select
            showSearch
            placeholder="Select a chart type"
            onChange={handleChartChange}
            value={selectedChart || undefined}
            style={{ width: "100%" }}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {chartOptions.map((chart) => (
              <Option key={chart.value} value={chart.value}>
                {chart.label}
              </Option>
            ))}
          </Select>
        </Col>

        {/* Time Format */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <div className="selector-label">Time Format</div>
          <Select
            value={timeFormat}
            style={{ width: "100%" }}
            onChange={setTimeFormat}
            options={[
              { label: "Daily", value: "daily" },
              { label: "Weekly", value: "weekly" },
              { label: "Monthly", value: "monthly" },
            ]}
          />
        </Col>

        {/* Button */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <Button
            type="primary"
            block
            className="generate-btn"
            style={{
              marginTop: "10px",
            }}
            onClick={Graph_data}
          >
            Generate Graph
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default DateEngineChartSelector;
